import React, { Component } from "react";
import PropTypes from "prop-types";
import "react-toastify/dist/ReactToastify.css";

import CobeeLoader from "app/components/CobeeLoader";
import { displayNotificationCard } from "./alert/display-notification-subsidy-recurrent";
import { clearCache } from "../infrastructure/employees-filter";
import SidebarV2 from "../v2/ui/components/SidebarV2";

export class Website extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  initComponent = async () => {
    const { onMount } = this.props;
    clearCache();
    if (onMount) {
      await onMount();
    }
    this.setState({ isLoading: false });
    displayNotificationCard();
  };

  componentDidMount() {
    this.initComponent();
  }

  render() {
    const { onMount, children } = this.props;
    const { isLoading } = this.state;
    return (
      <div id="container-app" className="flex">
        <SidebarV2 />
        {isLoading && <CobeeLoader />}

        {onMount ? (
          <div className="container-flex" id="page-container" />
        ) : (
          children
        )}
        <div id="modal-container" />
      </div>
    );
  }
}

Website.defaultProps = {
  onMount: () => {},
  children: undefined,
};

Website.propTypes = {
  onMount: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};
